// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/abs/views/account/Register/Domestic/Phone/Agreement/index.less
// module id = 826
// module chunks = 42